// tslint:disable: no-inferrable-types

import { Component, Input } from '@angular/core';

@Component({
    selector: 'fui-fieldset-legend',
    template: `
    <legend>
        <div>
            <span>{{ label }}</span>
            <div><ng-content></ng-content></div>
        </div>
    </legend>
    `,
    standalone: false
})
export class FUIFieldsetLegendComponent {
    @Input() label: string = '';
}
